import { useState } from 'react';
import type { SupportedLanguage } from '@allergen-lens/shared-logic';
import { loadTranslations } from '@allergen-lens/shared-logic';
import translations from '@/data/translations.json';
import { Tooltip } from './Tooltip';
import styles from './LanguageSelector.module.css';

const LANGUAGES: { value: SupportedLanguage; label: string }[] = [
  { value: 'en', label: 'English' },
  { value: 'de', label: 'Deutsch' },
  { value: 'fr', label: 'Français' },
  { value: 'es', label: 'Español' },
  { value: 'it', label: 'Italiano' },
  { value: 'nl', label: 'Nederlands' },
  { value: 'pt', label: 'Português' },
  { value: 'pl', label: 'Polski' },
];

// Load translations on module import
loadTranslations(translations as import('@allergen-lens/shared-logic').TranslationEntry[]);

export function LanguageSelector() {
  const [language, setLanguage] = useState<SupportedLanguage>('en');

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newLang = e.target.value as SupportedLanguage;
    setLanguage(newLang);
    // Translation mapper is already loaded; detectAllergens can use translateTerm
  };

  return (
    <div className={styles.languageSelector}>
      <label htmlFor="lang-select" className={styles.label}>Source language:</label>
      <select id="lang-select" className={styles.select} value={language} onChange={handleChange} title="Language of the ingredient list being analyzed. Selecting the correct language improves allergen synonym matching.">
        {LANGUAGES.map((lang) => (
          <option key={lang.value} value={lang.value}>
            {lang.label}
          </option>
        ))}
      </select>
      <Tooltip content="Language of the ingredient list. Selecting the correct language improves synonym matching for allergen detection." />
    </div>
  );
}
